import store from '@/store';
import { parseError } from '@/utils/AppError';
import logoutUtil from '@/utils/LogoutUtil';
import Constants from '@/utils/Constants';

const requestSuccessCallback = config => {
  config.headers.userPath = 'authorised';
  config.headers.logout = 'authorised';
  const csrfMatch = document.cookie
    .match('(^|;)\\s*csrf_access_token\\s*=\\s*([^;]+)');
  if (csrfMatch) {
    config.headers['X-CSRF-TOKEN'] = csrfMatch.pop();
  }
  return config;
};

const requestErrorCallback = (err) => Promise.reject(err);

const responseSuccessCallback = res => res.data;

let multiLoginAlertShown = false;

const responseErrorCallback = (err) => {
  // On 401 (expired/invalid JWT), clear session and redirect to login
  if (err.response && err.response.status === 401) {
    if (err.response.data && err.response.data.reason === 'multi_login') {
      if (!multiLoginAlertShown) {
        multiLoginAlertShown = true;
        // eslint-disable-next-line no-alert, max-len
        alert('You have been logged out because your account was accessed from another device/browser.');
      }
    }
    logoutUtil.logout();
    if (Constants.isProduction) {
      window.location.href = '/login';
    } else {
      window.location.href = '/loginstg';
    }
    return Promise.reject(err);
  }
  parseError(err);
  return Promise.reject(err);
};

export default (axiosInstance, silent = false) => {
  if (!silent) {
    axiosInstance.interceptors.request.use(
      (payload) => {
        store.commit('setLoading', true);
        return requestSuccessCallback(payload);
      },
      requestErrorCallback,
    );

    axiosInstance.interceptors.response.use(
      (payload) => {
        store.commit('setLoading', false);
        if (payload.headers.status === '0') {
          // Clear HttpOnly cookie via /sa/logout before redirecting
          fetch('/api/v1/sa/logout', { credentials: 'include' })
            .finally(() => {
              logoutUtil.logout();
              if (Constants.isProduction) {
                window.location.href = '/login';
              } else {
                window.location.href = '/loginstg';
              }
            });
        }
        return responseSuccessCallback(payload);
      },
      (payload) => {
        store.commit('setLoading', null);
        return responseErrorCallback(payload);
      },
    );
  } else {
    axiosInstance.interceptors.request.use(
      requestSuccessCallback,
      requestErrorCallback,
    );

    axiosInstance.interceptors.response.use(
      responseSuccessCallback,
      responseErrorCallback,
    );
  }
  return axiosInstance;
};
